import { createContext, useCallback, useContext, useMemo } from 'react'

const SpeechContext = createContext()

export const SpeechProvider = ({ children }) => {
  const speech = window.speechSynthesis

  const speak = useCallback((text) => {
    const utterance = new SpeechSynthesisUtterance(text)
    utterance.lang = 'fr-FR'

    speech.cancel()
    speech.speak(utterance)
  }, [speech])

  const stopSpeak = useCallback(() => {
    speech.cancel()
  }, [speech])

  const value = useMemo(() => ({
    speak,
    stopSpeak,
  }), [speak, stopSpeak])

  return (
    <SpeechContext.Provider value={value}>
      {children}
    </SpeechContext.Provider>
  )
}

export const useSpeech = () => {
  const context = useContext(SpeechContext)
  if (!context) {
    throw new Error('useSpeech must be used within a SpeechProvider')
  }
  return context
}
